import {
  SESSION_COGNITO_LOGIN_BEGIN,
  SESSION_COGNITO_LOGIN_SUCCESS,
  SESSION_COGNITO_LOGIN_FAILURE,
  SESSION_COGNITO_LOGIN_DISMISS_ERROR,
} from './constants';
import Amplify, { Auth } from 'aws-amplify'
import Cookie from '~/common/cookie'
import Cookies from 'universal-cookie'
import { logoutWithRedirectBack } from '~/common/utils'

Amplify.configure({
  Auth: {
    identityPoolId: process.env.NALURI_APP_COGNITO_IDENTITY_POOL_ID,
    region: process.env.NALURI_APP_COGNITO_REGION,
    userPoolId: process.env.NALURI_APP_COGNITO_USER_POOL_ID,
    userPoolWebClientId: process.env.NALURI_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
    authenticationFlowType: 'USER_PASSWORD_AUTH'
  }
});

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function cognitoLogin(email, password) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: SESSION_COGNITO_LOGIN_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.

      const doRequest = Auth.signIn(email, password);
      doRequest.then(
        (cognitoUser) => {
          const tokens = cognitoUser.signInUserSession

          if (tokens) {
            Cookie.set('__naluri__', tokens.idToken.jwtToken)

            dispatch({
              type: SESSION_COGNITO_LOGIN_SUCCESS,
              data: tokens.idToken.jwtToken,
            });
          } else {
            dispatch({
              type: SESSION_COGNITO_LOGIN_FAILURE,
              data: { error: cognitoUser },
            });
          }

          resolve(cognitoUser);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: SESSION_COGNITO_LOGIN_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function refreshToken() {
  return (dispatch) => {
    return Auth.currentSession().then(res => {
      const cookie = new Cookies()
      const token = cookie.get('__naluri__')

      if (token !== res.idToken.jwtToken) {
        Cookie.set('__naluri__', res.idToken.jwtToken)
      }
      return res.idToken.jwtToken
    }).catch((err) => {
      if (err.code === "NotAuthorizedException") {
        // If refresh token, or current session is expired,
        // Logout and redirect users.
        logoutWithRedirectBack()
      }
    });
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissCognitoLoginError() {
  return {
    type: SESSION_COGNITO_LOGIN_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SESSION_COGNITO_LOGIN_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        authenticated: null,
        token: null,
        cognitoLoginPending: true,
        cognitoLoginError: null,
      };

    case SESSION_COGNITO_LOGIN_SUCCESS:
      // The request is success
      return {
        ...state,
        token: action.data,
        cognitoLoginPending: false,
        cognitoLoginError: null,
      };

    case SESSION_COGNITO_LOGIN_FAILURE:
      // The request is failed
      return {
        ...state,
        authenticated: null,
        token: null,
        cognitoLoginPending: false,
        cognitoLoginError: action.data.error,
      };

    case SESSION_COGNITO_LOGIN_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        cognitoLoginError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/session/redux/cognitoLogin.js